import ChartsPagePromotor from './ChartsPagePromotor';

export default ChartsPagePromotor;
